<template>
    <q-modal v-model="showEditDialog" no-backdrop-dismiss>
      <q-toolbar color="primary" style="justify-content:space-between;">
                <q-toolbar-title shrink>
                    <div v-if="materialId==-1">Новый материал</div>    
                    <div v-if="materialId!=-1">Редактирование материала</div>
                </q-toolbar-title>
                
        </q-toolbar>       
        
        <div class="param-container">
            <q-input 
                name="materialName"
                v-model="materialName" 
                float-label="Название материала" 
                placeholder="Ламинированный баннер 440 гр" 
                v-validate="{required : true}"
            />            
            
            <q-select
                multiple
                chips
                name = "materialDirections"
                v-validate="{required : true}"
                v-model="materialDirections"
                :options="selectDirections"
                float-label='Где используется материал'
                style='margin-top:50px'
            />

            <q-select
                multiple
                chips
                v-model="materialPost"
                :options="selectPosts"
                float-label='Допустимые виды обработки'
                style='margin-top:50px'
            />


        </div>
        <div class='button-container'>
            <q-btn
                color="negative"
                @click="closeEditDialog"
                label="Отмена"
                outline
            />
            <q-btn
                color="positive"
                :loading='isLoading'
                @click="saveEditDialog"
                style="margin-left:20px; width:150px;"
            >
                <span v-if='materialId==-1'>Добавить</span>
                <span v-if='materialId != -1'>Сохранить</span>
            </q-btn>

        </div>
    </q-modal>

</template>

<script>

/* eslint-disable */
export default {
    name : 'materialEditDialog',
    
    data () {
            return {
                materialId : -1, // идентификатор ИД материала. если -1 - то добавляем новый материал
                showEditDialog : false, // флаг видимости диалога
            //Параметры материала    
                materialName : '',
                materialDirections : [],
                materialPost : [],
                isLoading : false,
            }
    },

    created() {
        eventBus.$on("showEditMaterialDialog", (materialId)=> {
            this.materialId = materialId;
            if (materialId > -1) { //значит редактируем и надо бы заполнить поля

                if (this.$store.getters.getMaterialById(materialId) != undefined) {
                    let q = this.$store.getters.getMaterialById(materialId);
                    this.materialName = q.name;
                    this.materialDirections = JSON.parse(q.directions);
                    this.materialPost = JSON.parse(q.post_types);
                }

            }
            this.showEditDialog = true; // показываем диалоговое окно
        });
    },

    beforeDestroy() {
        eventBus.$off('showEditMaterialDialog');
    },

    computed : {
        selectDirections() {
            var list = [];
            var result = [];
            //нужно получить список направлений
            if (this.$store.getters.getAllDirections != undefined) list = this.$store.getters.getAllDirections;  // получили список 

            list.forEach(item => {
                 result.push({
                    label:item.name,
                    value:item.id,
                    icon : item.icon,
                 }); 
            });
            return result;
        },

        selectPosts() {
            var list = [];
            var result = [];

            if (this.$store.getters.getAllPostTypes != undefined) list = this.$store.getters.getAllPostTypes;
            
            list.forEach(item => {
                let icon_path = "/static/"+item.icon;
                result.push({
                    label : item.name,
                    value : item.id,
                    rightAvatar : icon_path
                });
            });
            return result;
        },
    },

    methods : {
        
        clearFormData() {
            this.materialName = '';
            this.materialDirections = [];
            this.materialPost = [];
        },

        closeEditDialog() {
            this.showEditDialog = false;
            this.clearFormData();
        },

        saveEditDialog() {

            this.$validator.validate().then(result => { // проверяем заполнение формы

                if (result) { // если все путем - то запускаем процедуру сохранения

                    this.isLoading = true;

                    var data = {
                        directions : JSON.stringify(this.materialDirections),
                        id : this.materialId,
                        name : this.materialName,
                        post_types: JSON.stringify(this.materialPost)
                    };

                    this.$store.dispatch('saveMaterial', data)
                    .then(()=>{
                        this.isLoading = false;
                        this.showEditDialog = false;
                        this.clearFormData();
                        this.$admns.showNotify('Запись успешно сохранена','success','Сообщение системы');

                    });

                } else {
                     if (this.materialName == '') { this.$admns.showNotify('Нужно заполнить имя материала','error','Сообщение системы'); }
                     if (this.materialDirections.length == 0){ this.$admns.showNotify('Нужно указать, где используется материал','error','Сообщение системы');}
                }
            });

            
        },
    }

}


</script>

<style lang="scss" scoped>
    .param-container {
        padding:30px;
        width:600px;
        min-height:380px;
    }
    .button-container {
        padding:30px;
        text-align: right;
    }
</style>

